import { combineReducers } from 'redux'
import userReducer from './Auth/auth.reducer'
import bondReducer from './Bonds/bonds.reducer'

const rootReducer = combineReducers({
  user: userReducer,
  bonds: bondReducer,
})

export default rootReducer